<template>
  <div>
    <div class="relative -mt-12 lg:-mt-4">
      <svg
        class="editorial"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
      >
        <defs>
          <path
            id="gentle-wave"
            d="M-160 44c30 0 
   58-18 88-18s
   58 18 88 18 
   58-18 88-18 
   58 18 88 18
   v44h-352z"
          />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="50" y="0" fill="#1983d4" />
          <use xlink:href="#gentle-wave" x="50" y="3" fill="#1983d4" />
          <use xlink:href="#gentle-wave" x="50" y="6" fill="#0a65c2" />
        </g>
      </svg>
    </div>
    <footer class="bg-blue-sea text-white">
      <div class="container mx-auto px-6 pt-10 pb-6">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/4 text-center md:text-left">
            <h5 class="uppercase mb-6 font-bold text-3xl">
              <a
                id="changeLogo"
                class="bg-cover bg-no-repeat toggleColour no-underline hover:no-underline font-bold text-2xl lg:text-4xl flex relative h-10 w-40 logo"
                href="#"
              ></a>
            </h5>
          </div>
          <div class="w-full md:w-1/4 text-center md:text-left">
            <h5 class="mb-6 font-bold text-md">服務須知</h5>
            <ul class="mb-4">
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">常見問題</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">付款方式</a>
              </li>
            </ul>
          </div>
          <div class="w-full md:w-1/4 text-center md:text-left">
            <h5 class="mb-6 font-bold text-md">給旅行家</h5>
            <ul class="mb-4">
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">關於尋旅</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">Points 介紹</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">官方部落格</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">會員好禮</a>
              </li>
            </ul>
          </div>
          <div class="w-full md:w-1/4 text-center md:text-left">
            <h5 class="mb-6 font-bold text-md">合作夥伴</h5>
            <ul class="mb-4">
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">部落客/攝影師合作計畫</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">聯盟行銷</a>
              </li>
              <li class="mt-2">
                <a href="#" class="text-gray-200 text-sm">申請成為旅行規劃師</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <!-- gotop -->
    <GoTop />
  </div>
</template>
<script>
import GoTop from "@/components/GoTop.vue";

export default {
  components: {
    GoTop
  }
};
</script>